/*
 featuresRepo

 This class retrieves enabled features

 */

import $ from 'jquery';
import { authService } from '../login';

var FeaturesRepo = (function () {
    var self = this;

    function featuresRepo() {

    }

    var _featuresObject = null;

    featuresRepo.prototype.getFeatures = function () {
        var deferred = $.Deferred();

        if (_featuresObject !== null) {
            deferred.resolve(_featuresObject)
        }
        else {
            $.ajax({
                url: `${API_URL}/features`,
                type: 'GET',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("Authorization", authService.getAuthorizationHeaderValue());
                },
                success: function (results, status, jqXhr) {
                    _featuresObject = results;
                    deferred.resolve(results);
                },
                error: function (jqXhr, status, error) {
                    authService.handleApiResult(jqXhr);
                    deferred.reject(jqXhr);
                }
            });
        }
 
        return deferred.promise();
    }

    return featuresRepo;
})();

export const featuresRepo = new FeaturesRepo();
